/* Surcharges JS Le Grand Chic France — chargées une seule fois (defer, après theme.js) depuis layout/theme.liquid.
   Un bloc IIFE par ticket, ajouté en fin de fichier, encadré par « T1X … début » / « fin T1X » (fusion git union). */

/* ===== T11 — header sticky + barre « Ajouter au panier » mobile (PDP) : début ===== */
(function () {
  'use strict';

  /* 1. Hauteur réservée de l'en-tête collé.
     theme.js (stickyHeaderHeight) fige la hauteur de .site-header-sticky au DOM ready et à chaque resize en mesurant
     l'en-tête tel qu'il est à cet instant : trop petite si l'en-tête est collé (padding réduit dès 590 px) ou si le
     logo n'est pas encore chargé. Au retour en haut, l'en-tête recouvre alors le haut du contenu.
     Correctif : après le recalcul de Motion (debounce 50 ms) et au load, mesurer l'en-tête dans son état non collé.
     La valeur est aussi posée en min-height : en état collé, le recalcul de Motion (192 au lieu de 222 px dès 590 px)
     ne change plus la mise en page, donc plus de décalage du contenu à chaque resize, avec ou sans ancrage de défilement.
     Hors état collé, min-height est retirée au resize pour que Motion suive la vraie hauteur (rotation, largeur). */
  var header = document.querySelector('.site-header[data-sticky="true"]');
  if (header) {
    var reserveHeaderHeight = function () {
      var wrap = header.parentNode;
      if (!wrap || !wrap.classList || !wrap.classList.contains('site-header-sticky')) return;
      var states = ['site-header--stuck', 'site-header--opening'].filter(function (c) {
        return header.classList.contains(c);
      });
      states.forEach(function (c) { header.classList.remove(c); });
      var cs = window.getComputedStyle(header);
      var h = header.getBoundingClientRect().height + parseFloat(cs.marginTop) + parseFloat(cs.marginBottom);
      states.forEach(function (c) { header.classList.add(c); });
      wrap.style.height = wrap.style.minHeight = h + 'px';
    };
    var resizeTimer;
    window.addEventListener('resize', function () {
      if (!header.classList.contains('site-header--stuck')) header.parentNode.style.minHeight = '';
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(reserveHeaderHeight, 150);
    });
    window.addEventListener('load', reserveHeaderHeight);
    // logo sans dimensions (tant que T16 n'est pas en ligne) : la hauteur change à son arrivée
    Array.prototype.forEach.call(header.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', reserveHeaderHeight);
    });
  }

  /* 2. Barre « Ajouter au panier » (PDP, écrans ≤ 768 px et ≥ 500 px de haut).
     - ne soumet rien elle-même : clic relayé sur le vrai bouton #AddToCart-<id> (formulaire AJAX de Motion,
       garde anti double envoi status.loading de theme.AjaxProduct, ouverture du tiroir panier) ;
     - variante : événement jQuery « variantChange » déclenché par slate.Variants sur #ProductSection-<id>,
       écouté avec theme.jQuery (un autre jQuery chargé par une app ne recevrait pas l'événement) ;
     - visible seulement quand ni le prix ni le bouton principal ne sont à l'écran. */
  var bar = document.querySelector('[data-lgc-satc]');
  var theme = window.theme;
  var $ = theme && theme.jQuery;
  if (!bar || !$ || !theme.Currency || !theme.settings || !('IntersectionObserver' in window)) return;

  var productId = bar.getAttribute('data-product-id');
  var section = document.getElementById('ProductSection-' + productId);
  var mainBtn = document.getElementById('AddToCart-' + productId);
  var mainPrice = document.getElementById('ProductPrice-' + productId);
  var form = document.getElementById('AddToCartForm-' + productId);
  if (!section || !mainBtn || section.closest('.modal')) return;

  var root = document.documentElement;
  var btn = bar.querySelector('[data-lgc-satc-btn]');
  var label = bar.querySelector('[data-lgc-satc-label]');
  var priceEl = bar.querySelector('[data-lgc-satc-price]');
  var variantEl = bar.querySelector('[data-lgc-satc-variant]');
  var mq = window.matchMedia('(max-width: 768px) and (min-height: 500px)');
  var inView = { btn: true, price: !!mainPrice };

  function setVisible(show) {
    if (bar.classList.contains('is-visible') === show) return;
    if (show) {
      bar.removeAttribute('inert');
      bar.setAttribute('aria-hidden', 'false');
      bar.classList.add('is-visible');
      root.classList.add('lgc-satc-on');
    } else {
      if (bar.contains(document.activeElement)) mainBtn.focus({ preventScroll: true });
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
      root.classList.remove('lgc-satc-on');
    }
  }

  function update() {
    setVisible(mq.matches && !inView.btn && !inView.price);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      inView[entry.target === mainBtn ? 'btn' : 'price'] = entry.isIntersecting;
    });
    update();
  });
  io.observe(mainBtn);
  if (mainPrice) io.observe(mainPrice);

  if (mq.addEventListener) mq.addEventListener('change', update);
  else if (mq.addListener) mq.addListener(update);

  // Changement de variante : mêmes données et même formatage que theme.Product.updatePrice / updateCartButton
  $(section).on('variantChange.lgcSatc', function (evt) {
    var variant = evt.variant;
    var strings = theme.strings || {};
    if (!variant) {
      btn.disabled = true;
      label.innerHTML = strings.unavailable;
      return;
    }
    if (variantEl) variantEl.textContent = variant.title;
    priceEl.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
    btn.disabled = !variant.available;
    label.innerHTML = variant.available ? strings.addToCart : strings.soldOut;
  });

  // Envoi en cours sur le bouton principal (classe btn--loading posée par theme.AjaxProduct) : reflété sur la barre
  new MutationObserver(function () {
    btn.classList.toggle('btn--loading', mainBtn.classList.contains('btn--loading'));
  }).observe(mainBtn, { attributes: true, attributeFilter: ['class'] });

  // Échec de l'ajout : theme.AjaxProduct insère .errors en tête du formulaire, hors écran quand on utilise la barre
  if (form) {
    new MutationObserver(function () {
      var err = form.querySelector('.errors');
      if (err && bar.classList.contains('is-visible')) err.scrollIntoView({ block: 'center' });
    }).observe(form, { childList: true });
  }

  btn.addEventListener('click', function () {
    if (btn.disabled || mainBtn.disabled || mainBtn.classList.contains('btn--loading')) return;
    mainBtn.click();
  });
})();
/* ===== fin T11 ===== */
/* ===== T11b — lien d'évitement « Passer au contenu » sous l'en-tête collant : début ===== */
(function () {
  'use strict';

  /* Publie la hauteur de l'en-tête EN ÉTAT COLLÉ (192 px au-delà de 590 px, 117 px en dessous ;
     203 px et 123 px sur l'accueil, dont l'en-tête est plus haut) dans --lgc-header-stuck, lue en
     scroll-padding-top par le bloc T11b de custom-lgc.css. Mesure indépendante de reserveHeaderHeight
     (bloc T11), qui mesure au contraire l'en-tête NON collé : les deux fonctions sont synchrones et
     restaurent l'état des classes, elles ne peuvent pas s'entrelacer. Aucun déplacement de mise en page
     (tuples {scrollY, #MainContent, h1, prix, hauteur du conteneur, scrollHeight} identiques avant/après
     à 375, 768 et 1440 px ; CLS ≤ 0,0005) : .site-header-sticky porte déjà une hauteur en ligne, posée
     par Motion puis par le bloc T11.
     Ordonnancement : theme.js pose le conteneur .site-header-sticky dans un callback jQuery ready
     (theme.js.liquid:1746), exécuté APRÈS les écouteurs DOMContentLoaded — d'où le setTimeout(…, 0).
     Tant que la variable n'est pas publiée, le repli var(--lgc-header-stuck, 0px) = comportement actuel :
     aucune régression possible si le JS échoue. */
  var header = document.querySelector('.site-header[data-sticky="true"]');
  if (!header) return;

  function publishStuckHeight() {
    var wrap = header.parentNode;
    // .site-header-sticky est créé par theme.js : sans lui, l'en-tête n'est jamais collé
    if (!wrap || !wrap.classList || !wrap.classList.contains('site-header-sticky')) return;
    var stuck = header.classList.contains('site-header--stuck');
    if (!stuck) header.classList.add('site-header--stuck');
    var h = header.getBoundingClientRect().height;
    if (!stuck) header.classList.remove('site-header--stuck');
    document.documentElement.style.setProperty('--lgc-header-stuck', Math.round(h) + 'px');
  }

  var resizeTimer;
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(publishStuckHeight, 0);
  });
  window.addEventListener('load', publishStuckHeight);
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(publishStuckHeight, 150);
  });
  // logo ou image d'en-tête pas encore chargé : la hauteur change à son arrivée
  Array.prototype.forEach.call(header.querySelectorAll('img'), function (img) {
    if (!img.complete) img.addEventListener('load', publishStuckHeight);
  });
})();
/* ===== fin T11b ===== */
/* ===== T20 — réserve du hero calée sur le contenu PEINT de l'en-tête, publiée en variable CSS : début ===== */
(function () {
  'use strict';

  /* Sur l'accueil, l'en-tête est posé en position:absolute au-dessus du hero (.header-wrapper--sticky,
     réglage sticky_index de sections/header.liquid:17-21). Aucune règle CSS ne peut connaître sa
     géométrie : elle est mesurée ici et publiée dans --lgc-hero-pad, consommée par le bloc T20 de
     custom-lgc.css.

     CE QU'ON MESURE : le bas du contenu PEINT, pas la boîte du conteneur. .header-wrapper descend à
     177,1 px (320-390), 154,7 px (414-589) et 269,9 px (≥ 590), mais son fond est un dégradé
     linear-gradient(rgba(0,0,0,.3), rgba(0,0,0,0)) transparent en bas, et .site-header ajoute 10 à
     30 px de padding-bottom vide : plus bas que 153,8 px (320-390), 131,4 px (414-589) et 226,6 px
     (≥ 590) — le bas de l'image du logo — il n'y a plus rien de peint, et le dernier pixel réellement
     encré est même à 126,5 / 104 / 170 px, le bas du PNG étant transparent. Réserver la boîte faisait
     descendre le bloc titre + CTA de 120 px à 1280 et 1440 px alors que le titre de Motion commençait
     déjà 7,5 px SOUS cette dernière boîte peinte (234,1 contre 226,6). On prend donc le bas des boîtes
     qui peignent vraiment : .announcement (fond opaque
     #042350), .site-header__logo (l'image) et .site-nav (navigation et rangée d'icônes). Les colonnes
     .header-item sont écartées : étirées par le flex, elles descendent 13,3 px plus bas que leur
     contenu.

     COMMENT ON EN DÉDUIT LE PADDING. .hero__text-content est une cellule de tableau en
     vertical-align:middle : pour une table de hauteur H, le haut du bloc titre est à
     PT + (H − PT − PB − C) / 2, C étant la hauteur du bloc titre + CTA (modèle vérifié au dixième de
     pixel). On veut ce haut à « cible » = bas peint + MARGE, d'où deux cas :
       — la table reste à son plancher Hmin : PT = 2 × (cible − haut du hero) − Hmin + PB + C ;
       — la table grandit (règle 2 du CSS, height:auto + min-height) : H = PT + PB + C et PT = cible − haut du hero.
     Le second cas s'applique dès que le premier dépasse le plancher, et Math.min() des deux expressions
     sélectionne exactement le bon (démontré : l'une passe au-dessus de l'autre au point de bascule).

     UNE SEULE BORNE, ET C'EST UN PLANCHER : PT ≥ PB + 30, soit la position exacte de Motion (padding
     50/20 sous 590 px, 90/60 au-delà : (50 − 20) / 2 = (90 − 60) / 2 = 15). Le correctif ne peut donc
     JAMAIS placer le bloc plus haut que la production.
     PAS DE PLAFOND « LIGNE DE FLOTTAISON » — il a été RETIRÉ. Tant qu'il existait, la réserve était
     rabattue dès que le bas du CTA serait passé sous le pli, ce qui REMETTAIT le titre dans le logo,
     c'est-à-dire le défaut même que T20 corrige. Mesuré sur la préversion en fenêtre basse (560 px de
     haut), plafond en place : chevauchement du titre NOMINAL avec la dernière boîte peinte = 49,5 px à
     590, 640 et 710 px (45,0 px avant le lot 4 : pire qu'avant le correctif), 98,5 px avec une ligne de
     titre de plus et 124,5 px avec deux ; 49,5 puis 98,5 px à 768 px dès +1 et +2 lignes ; 39,5 px à
     1024 px à +2 lignes. Sans le plafond, ces 13 largeurs × 3 longueurs de titre donnent 0 partout.
     Rien ne reste à protéger contre le rognage : la règle 2 du CSS rend le hero extensible (height:auto
     + min-height), le CTA descend avec lui et garde les 28 px de padding-bottom de la cellule. Toute
     borne SUPÉRIEURE serait par construction capable de réduire la réserve sous la valeur qui annule le
     chevauchement — il n'y en a donc aucune, y compris quand le hero ne peut PAS grandir (hauteur de
     section changée dans l'éditeur, .hero--650px absente) : dans ce cas le CTA peut être rogné par
     l'overflow:hidden de Motion, mais le titre reste lisible, et la lisibilité prime sur le cadrage.
     Valeurs publiées avec le contenu actuel, aux 13 largeurs 320 · 360 · 375 · 390 · 414 · 589 · 590 ·
     640 · 710 · 768 · 1024 · 1280 · 1440 : 141 · 115 · 115 · 115 · 71 · 58 · 225 · 225 · 225 · 173 ·
     111 · 59 · 59 px (contre 177 · 177 · 177 · 177 · 155 · 155 · 270 · 270 · 270 · 270 · 270 · 270 ·
     270 px quand on réservait la boîte). Le
     plancher est atteint à 589 px (58 = 28 + 30) : à cette largeur le bloc retrouve exactement la
     position de Motion, et c'est correct — rien n'y chevauche.

     POURQUOI LA MESURE NE DÉPEND PLUS DE L'ÉTAT COLLÉ. Une fois .site-header en position:fixed (classe
     site-header--stuck de Motion, theme.js:1519 et 1774, seuil 250 px), ses enfants ne sont plus dans le
     repère de .header-wrapper et sa géométrie interne change : padding 30 → 15 px (≥ 590) et surtout
     theme.js retire is-light du conteneur (theme.js:1777), ce qui remplace le logo inversé par le logo
     normal, dont le rapport d'image diffère — mesuré, le bas peint tombe de 226,6 à 215,6 px à 1024 et
     1280 px, et de 153,8 à 147,8 px à 375 px. La version précédente sautait donc la mesure tant que
     l'en-tête était décollé : après un changement de largeur pendant le défilement, la réserve restait
     périmée et le titre SAUTAIT au retour en haut de page, alors qu'il était déjà à l'écran : réserve
     périmée de 83 px au plus (58 px conservés là où 141 px sont dus, 589 → 320 px), soit un saut du
     titre de 41,50 px à cet endroit — la cellule étant centrée verticalement, le titre ne prend que la
     moitié de l'écart de padding —, de 26,00 px à 1280 → 1024 px comme à 768 → 590 px et de 21,00 px à
     320 → 256 px ; à 1024 px le titre restait posé 15,0 px DANS la zone peinte de l'en-tête (211,6 px
     pour un bas peint à 226,6 px) le temps que l'écouteur de défilement rejoue la mesure. Les mêmes
     quatre cas donnent 0,00 px de saut après correction. On rétablit donc, le temps de la mesure et dans
     la MÊME tâche synchrone (aucune peinture ne peut s'intercaler : captures d'écran identiques octet
     pour octet), les deux classes que Motion enlève — procédé déjà employé par le bloc T11b de ce même
     fichier, qui retire .site-header--stuck et .site-header--opening pour mesurer la hauteur de
     l'en-tête ; la valeur obtenue est alors exacte au centième près, décollé ou non (écart mesuré
     0,00 px à 375, 1024 et 1280 px, y compris après un changement de largeur effectué pendant le
     défilement). Le MutationObserver republie à chaque bascule réelle de
     l'état collé ; les deux mutations que basPeint() fait et défait ne laissent aucun écart net, la
     comparaison avec etaitColle les ignore et aucune boucle n'est possible.

     Compatible T11 : theme.js (stickyHeaderHeight) et la garde du bloc T11 figent la hauteur de
     .site-header-sticky, mais cette valeur n'entre pas dans le calcul — pendant les ~150 ms où elle est
     périmée après un changement de largeur, les boîtes du logo et des icônes, elles, sont déjà justes.
     sections/header.liquid:22-24 pose la même classe sur les pages collection à image : il n'y a pas de
     hero, publier() sort avant toute mesure et la variable n'y est jamais écrite.
     Paysage téléphone (812×375) : la garde min-height:500px du CSS neutralise les deux règles, le
     padding reste celui de Motion (90/60) et la variable publiée n'est consommée par personne — rendu
     mesuré identique au pixel à celui d'avant le correctif.

     CLS. Ce bloc est chargé en defer : il déplace le bloc titre après la première image, le décalage est
     donc réel et non nul — mesuré sur 3 chargements, 0,0161 / 0,00916 / 0,01283 à 375 × 812 px, dont 0,00916
     imputable au bloc (sources du décalage : H1.hero__title et .hero__link) ; référence sans le bloc,
     même page et même fenêtre : 0,00219 / 0,00219 / 0,00086. À 1440 × 900 px, 0,00068 / 0,00115 /
     0,00183 sans aucun décalage imputable au bloc (la valeur publiée y vaut 59 px pour un repli CSS de
     58 px). En dessous du seuil de 0,01 fixé pour ce tour, donc rien à réduire. L'affirmation « CLS 0 » de la
     version précédente était fausse ; elle est corrigée ici et dans scripts/verify.sh. */

  var wrap = document.querySelector('.header-wrapper--sticky');
  if (!wrap) return;

  var PORTEE = '.index-section--hero:first-child .slideshow-wrapper ';
  var PEINT = '.announcement, .site-header__logo, .site-nav';
  var COLLE = 'site-header--stuck'; // Motion : .site-header passe en position:fixed
  var CLAIR = 'is-light';           // Motion : retirée du conteneur quand l'en-tête se colle
  var MARGE = 8;   // px de dégagement entre le dernier pixel peint de l'en-tête et le haut du bloc titre
  var MOTION = 30; // px : padding-top − padding-bottom de Motion, à l'un et l'autre de ses points de rupture

  var root = document.documentElement;
  var entete = wrap.querySelector('.site-header');
  var last = -1;
  var planifie = false;
  var aRefaire = false;
  var etaitColle = !!(entete && entete.classList.contains(COLLE));
  var tardif;

  // Bas des boîtes qui peignent, exprimé depuis le haut de .header-wrapper.
  function mesurePeint() {
    var haut = wrap.getBoundingClientRect().top;
    var bas = -Infinity;
    Array.prototype.forEach.call(wrap.querySelectorAll(PEINT), function (el) {
      var c = window.getComputedStyle(el);
      if (c.visibility === 'hidden' || parseFloat(c.opacity) === 0) return;
      var r = el.getBoundingClientRect();
      if (r.width <= 0 || r.height <= 0) return;
      if (r.bottom - haut > bas) bas = r.bottom - haut;
    });
    return bas;
  }

  // Bas du contenu peint de l'en-tête POSÉ : indépendant du défilement ET de l'état collé, parce que les
  // deux classes que Motion change sont rétablies le temps de la mesure, sans peinture intermédiaire.
  function basPeint() {
    if (!entete) return null;
    var colle = entete.classList.contains(COLLE);
    var clair = wrap.classList.contains(CLAIR);
    if (colle) {
      entete.classList.remove(COLLE);
      if (!clair) wrap.classList.add(CLAIR);
    }
    // filet : si l'en-tête reste fixe pour une autre raison (tiroir ouvert, app tierce), on ne mesure pas
    var bas = window.getComputedStyle(entete).position === 'fixed' ? -Infinity : mesurePeint();
    if (colle) {
      entete.classList.add(COLLE);
      if (!clair) wrap.classList.remove(CLAIR);
    }
    return isFinite(bas) ? bas : null;
  }

  // Hauteur du bloc titre + CTA : union des enfants de la cellule, insensible au padding (vérifié de 0
  // à 400 px) et insensible aux animations d'entrée de Motion, qui portent sur .animation-contents.
  function hauteurTexte(cellule) {
    var haut = Infinity;
    var bas = -Infinity;
    Array.prototype.forEach.call(cellule.children, function (el) {
      var r = el.getBoundingClientRect();
      if (r.height <= 0) return;
      if (r.top < haut) haut = r.top;
      if (r.bottom > bas) bas = r.bottom;
    });
    return bas - haut;
  }

  function publier() {
    var hero = document.querySelector(PORTEE + '.hero');
    var cellule = document.querySelector(PORTEE + '.hero__text-content.vertical-center');
    if (!hero || !cellule) return; // hors accueil : aucune règle ne consomme la variable

    var peint = basPeint();
    if (peint === null) { aRefaire = true; return; }

    var rHero = hero.getBoundingClientRect();
    var texte = hauteurTexte(cellule);
    if (!rHero.height || !isFinite(texte) || texte <= 0) return;

    // plancher de la table : la hauteur figée de Motion, reprise en min-height par le CSS quand le hero
    // a le droit de grandir. Pas de min-height = le hero est bloqué à sa hauteur, qui sert alors de socle.
    var minH = parseFloat(window.getComputedStyle(hero).minHeight);
    var socle = (isFinite(minH) && minH > 0) ? minH : rHero.height;
    var basCellule = parseFloat(window.getComputedStyle(cellule).paddingBottom) || 0;

    var defile = window.pageYOffset || root.scrollTop || 0;
    var hautHero = rHero.top + defile;
    var cible = wrap.getBoundingClientRect().top + peint + defile + MARGE;

    var t = cible - hautHero;
    var p = Math.min(2 * t - socle + basCellule + texte, t);
    // plancher = position de Motion ; aucune borne supérieure (voir le commentaire du bloc)
    p = Math.max(p, basCellule + MOTION);

    aRefaire = false;
    // seuil de 1 px : pas de réécriture sur un arrondi, donc pas de boucle avec le ResizeObserver
    var v = Math.round(p);
    if (Math.abs(v - last) >= 1) {
      last = v;
      root.style.setProperty('--lgc-hero-pad', v + 'px');
    }
  }

  // une seule mesure par image : publier() lit la mise en page, le ResizeObserver et resize peuvent
  // se déclencher plusieurs fois par image
  function planifier() {
    if (planifie) return;
    planifie = true;
    var suite = function () { planifie = false; publier(); };
    // appel porté par window : en mode strict, un requestAnimationFrame détaché lève « Illegal invocation »
    if (window.requestAnimationFrame) window.requestAnimationFrame(suite);
    else window.setTimeout(suite, 16);
  }

  publier();

  if (window.ResizeObserver) {
    var ro = new ResizeObserver(planifier);
    // l'en-tête : repliement de la barre d'annonce, arrivée du logo, rotation
    ro.observe(wrap);
    // le hero et le titre : le calcul dépend de leurs hauteurs, qui changent au re-découpage du titre
    // en lignes et au passage du hero de 422 à 650 px. Aucune boucle : le résultat ne dépend ni de la
    // hauteur courante du hero (on prend son min-height, constant) ni du padding posé (hauteur du bloc
    // titre mesurée identique de 0 à 400 px de padding) — publier() est idempotent, la deuxième passe
    // retrouve la même valeur et le seuil de 1 px coupe l'écriture.
    var cadre = document.querySelector(PORTEE + '.hero');
    var titre = document.querySelector(PORTEE + '.hero__title');
    if (cadre) ro.observe(cadre);
    if (titre) ro.observe(titre);
  }
  // bascule collé / posé : la valeur calculée ne change pas (basPeint la ramène à la géométrie de
  // l'en-tête posé), mais le logo affiché, lui, change — on republie à chaque bascule RÉELLE. Les deux
  // mutations que basPeint() fait et défait ne laissent aucun écart net : la comparaison les ignore,
  // aucune boucle n'est possible.
  if (entete && window.MutationObserver) {
    new MutationObserver(function () {
      var colle = entete.classList.contains(COLLE);
      if (colle === etaitColle) return;
      etaitColle = colle;
      planifier();
    }).observe(entete, { attributes: true, attributeFilter: ['class'] });
  }
  // resize est indispensable même avec le ResizeObserver : le calcul dépend aussi de la hauteur de la
  // fenêtre, qui peut changer sans que l'en-tête bouge. Le rappel à 250 ms attend le recalage de
  // .site-header-sticky par theme.js (anti-rebond de 150 ms) et le bloc T11.
  window.addEventListener('resize', function () {
    planifier();
    clearTimeout(tardif);
    tardif = setTimeout(publier, 250);
  });
  window.addEventListener('orientationchange', planifier);
  window.addEventListener('load', publier);
  // filet : si une mesure a malgré tout été sautée (en-tête resté fixe pour une autre raison), on la
  // rejoue au premier défilement suivant plutôt que de laisser une valeur périmée en place
  window.addEventListener('scroll', function () { if (aRefaire) planifier(); }, { passive: true });
  // le chargement des polices change la hauteur du titre, donc le calcul (police de titre : T28b)
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) document.fonts.ready.then(publier);
})();
/* ===== fin T20 ===== */

/* ===== T24 — carrousel de témoignages + sauts de ligne décoratifs : début ===== */
/* Le markup de « Elles l'ont fait » vient de l'éditeur (settings_data.json › advanced_content_ddqMMX ›
   blocks › html_JkXaXR) : on n'y touche pas. Le bloc T24 de custom-lgc.css transforme .lgc-test-grid en
   piste à défilement sous 768 px, mais une feuille de style ne peut pas poser d'attribut. Chrome ≥ 127
   rend les zones défilantes focusables d'office (vérifié : Flèche droite déplace bien la piste sans ce
   bloc), mais ni Safari ni les Chrome antérieurs : sans tabindex, les 2e et 3e témoignages y sont
   inatteignables au clavier (WCAG 2.1.1). Les attributs sont posés quand la piste défile réellement et
   retirés au-delà de 768 px, où la grille redevient statique.
   Le libellé est repris du <h2> de la section (aria-labelledby) : aucune chaîne en dur, aucune clé de
   locale, et il suit le titre si l'éditeur le change. */
(function () {
  'use strict';

  var sel = '.lgc-testimonials .lgc-test-grid';

  var sync = function () {
    var grids = document.querySelectorAll(sel);
    Array.prototype.forEach.call(grids, function (grid) {
      var cs = window.getComputedStyle(grid);
      var scrollable = cs.overflowX === 'auto' &&
        grid.scrollWidth - grid.clientWidth > 1 &&
        grid.children.length > 1;
      if (scrollable) {
        if (grid.getAttribute('tabindex') === '0') return;
        grid.setAttribute('tabindex', '0');
        grid.setAttribute('role', 'group');
        var title = grid.parentNode && grid.parentNode.querySelector
          ? grid.parentNode.querySelector('h2')
          : null;
        if (title) {
          if (!title.id) title.id = 'lgc-testimonials-title';
          grid.setAttribute('aria-labelledby', title.id);
        }
      } else if (grid.hasAttribute('tabindex')) {
        grid.removeAttribute('tabindex');
        grid.removeAttribute('role');
        grid.removeAttribute('aria-labelledby');
      }
    });
  };

  sync();
  window.addEventListener('load', sync);
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(sync, 150);
  });
  // éditeur de thème : la section est re-rendue, les nœuds précédents sont détachés
  document.addEventListener('shopify:section:load', sync);
}());

/* Sauts de ligne décoratifs de « Pourquoi choisir la méthode » (sections/text-columns.liquid).
   Le contenu vient de l'éditeur : on ne le modifie pas, on marque seulement les <br> qui ne produisent
   qu'une ligne vide, et custom-lgc.css les masque sous 768 px (règle 4 du bloc T24).
   Pourquoi pas en CSS : ses combinateurs structurels ignorent les nœuds texte. `p > br:first-child`
   atteint le premier <br> ÉLÉMENT même s'il suit du texte, et `br + br` atteint deux <br> séparés par
   une phrase. Mesuré en ligne à 375 px, le sélecteur CSS seul rendait `Lundi 9h<br>Mardi 10h<br>Jeudi
   14h<br>Samedi 11h` sur 1 ligne au lieu de 4.
   Règle appliquée ici : un <br> est décoratif s'il n'a aucun contenu signifiant AVANT lui dans son <p>,
   ou aucun APRÈS. Un contenu signifiant = un nœud texte contenant autre chose que des blancs ordinaires
   (l'espace insécable compte comme du texte), ou un élément autre qu'un <br>. Une coupure encadrée de
   texte des deux côtés est donc toujours conservée, `Premier<br><br>Second` compris.
   Idempotent : la classe est posée ou retirée à chaque passage. Sans ce bloc, aucun <br> n'est masqué. */
(function () {
  'use strict';

  var CLASSE = 'lgc-br-vide';

  // \s de JS inclut l'espace insécable : on l'exclut volontairement pour qu'un &nbsp; saisi
  // dans l'éditeur reste du contenu.
  var BLANCS = /[^ \t\n\r\f\v]/;

  var signifiant = function (n) {
    if (n.nodeType === 3) return BLANCS.test(n.nodeValue);
    return n.nodeType === 1 && n.nodeName !== 'BR';
  };

  var marquer = function () {
    // équivalent du :has(> .grid__item.medium-up--one-third) du CSS, sans dépendre de :has()
    var grilles = document.querySelectorAll('.template-index .index-section > .page-width > .grid--uniform');
    Array.prototype.forEach.call(grilles, function (grille) {
      if (!grille.querySelector(':scope > .grid__item.medium-up--one-third')) return;
      Array.prototype.forEach.call(grille.querySelectorAll('p > br'), function (br) {
        var avant = false, apres = false, n;
        for (n = br.previousSibling; n; n = n.previousSibling) {
          if (signifiant(n)) { avant = true; break; }
        }
        for (n = br.nextSibling; n; n = n.nextSibling) {
          if (signifiant(n)) { apres = true; break; }
        }
        if (avant && apres) { br.classList.remove(CLASSE); } else { br.classList.add(CLASSE); }
      });
    });
  };

  var sur = function () { try { marquer(); } catch (e) { /* :scope absent : contenu laissé tel quel */ } };

  sur();
  document.addEventListener('shopify:section:load', sur);
}());
/* ===== fin T24 ===== */
